import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc4BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const boolStats = itemsByField["bloc4.animalBool"]?.stats || null;
  const categoryStats = itemsByField["bloc4.animalCategory"]?.stats || null;
  const boolChartItems = [
    { category: t("common.yes", "Sí"), count: boolStats?.yes || 0 },
    { category: t("common.no", "No"), count: boolStats?.no || 0 },
  ];
  const categoryChartItems = (categoryStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc4.loading", "Carregant estadístiques de bloc4…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BooleanStatsPanel
            title={t("dashboard.blocks.bloc4.animalPresence", "Presència d’animals")}
            stats={boolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc4.animalCategories", "Categories d’animals")}
            stats={categoryStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc4.animalCategoryDistribution",
              "Distribució de categories d’animals"
            )}
            items={categoryChartItems}
          />

          <BarPlot
            title={t(
              "dashboard.blocks.bloc4.yesNoAnimals",
              "Respostes sí/no sobre animals"
            )}
            items={boolChartItems}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
